import get from 'lodash/get';
import { FieldInfo } from './interfaces';
import { DialogExtensionSDK } from 'contentful-ui-extensions-sdk';
import CTPicker from './CTPicker';

export async function renderDialog(sdk: DialogExtensionSDK): Promise<void> {
  const ID = 'dialog-root';
  const container = document.createElement('div');
  container.id = ID;
  container.style.display = 'flex';
  container.style.flexDirection = 'column';
  document.body.appendChild(container);

  const pickerModeIsVariant =
    get(sdk, ['parameters', 'invocation', 'pickerMode']) === 'variant';

  const fieldInfo: FieldInfo = {
    fieldType: get(sdk, ['parameters', 'invocation', 'fieldType']),
    fieldValue: get(sdk, ['parameters', 'invocation', 'fieldValue']),
  };

  const ctPicker = new CTPicker(
    container,
    sdk.parameters.installation,
    pickerModeIsVariant,
    fieldInfo
  );
  try {
    sdk.window.updateHeight(660);
    const result = await ctPicker.show();

    sdk.close(result);
  } catch (error) {
    if (error !== 'cancel') {
      // Widget is going to throw if the user closes the product picking dialog
      // without selecting a product. We need to swallow these exceptions and throw the rest.
      throw new Error(error);
    }
  }

  sdk.window.startAutoResizer();
}
